import styled from 'styled-components';

import { Carousel } from '@xing-com/carousel';
import { Divider } from '@xing-com/divider';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale000,
  space3XL,
  space4XL,
  spaceL,
  spaceM,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

const StyledHeadline = styled(Headline)`
  margin: ${space4XL} ${scale000} ${spaceM};

  @media ${mediaSmallOrTiny} {
    margin: ${space3XL} ${scale000} ${spaceM};
  }
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXL};
  }
`;

const StyledCarousel = styled(Carousel)`
  padding-left: ${scale000};
  padding-right: ${scale000};

  @media ${mediaSmallOrTiny} {
    margin: ${scale000} -${spaceL};
    padding-left: ${spaceL};
    padding-right: ${spaceL};
  }
`;

const StyledDivider = styled(Divider)`
  margin: ${space3XL} ${scale000} ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin: ${spaceXXL} ${scale000} ${space3XL};
  }
`;

export const Styled = {
  Headline: StyledHeadline,
  BodyCopy: StyledBodyCopy,
  Carousel: StyledCarousel,
  Divider: StyledDivider,
};
